import React from 'react';

import './App.scss';
import { Route , Switch, Redirect} from 'react-router-dom';
import router from './utils/router';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

import { Layout } from 'antd';
var { Content} = Layout;


// <Redirect to = '/404'/>

class App extends React.Component{
  constructor(props) {
    super(props)
  }
  render() {
    var height = document.body.clientHeight;
    var { props } = this;
    return (
      <Layout>
        <Header {...{ props }}/>
        <Content
        //style={{filter: "grayscale(100%)", minHeight: height - 95 * 2 + "px", margin: "95px 0px 0px 0px"}}
        style={{minHeight: height - 95 * 2 + "px", margin: "95px 0px 0px 0px"}}
        >
          <Switch>
            <Route exact path="/" render={() => <Redirect to={router[0].path} push />} />
            {
              router.map((route,index) => {
                if(!route.children){
                  return(
                    <Route 
                    key = {route.path}
                    path = {route.path}
                    component = {route.component}
                    {...{props}} />
                  )
                }else{
                  const children = route.children === undefined ? [] : route.children;
                  return (
                      <Route key={index} path={route.path} component={(router) => {
                          return <route.component router={children} {...router}></route.component>
                      }} ></Route>
                  )
                }
              })
            }
          </Switch>
        </Content>
        <Footer/>
      </Layout>
    )
  }
}

export default App;
